import React, { useEffect, useState } from 'react'
import { FaTrash, FaFilePdf, FaFileVideo } from "react-icons/fa";
import { BiSolidFileDoc, BiSolidFilePng } from "react-icons/bi"
import { BsFillFileImageFill } from "react-icons/bs"
import { FaEye } from 'react-icons/fa6';
import { uploadRes, uploadTodo } from '../../LMS_Redux/LMS_Slices/Assets/UploadImage';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addFileRes, addFileTodo } from '../../LMS_Redux/LMS_Slices/Assets/AddFile';
import { Link, useLocation } from 'react-router-dom';
import { fileListRes, fileListTodo } from '../../LMS_Redux/LMS_Slices/FileLibrary/FilesList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import { deleteFileRes, deleteFileTodo } from '../../LMS_Redux/LMS_Slices/FileLibrary/DeleteFile';
import Swal from 'sweetalert2';

export default function FileUpload() {

    const { state } = useLocation()
    const dispatch = useDispatch()
    const data = useSelector(state => state.fileList && state.fileList.data && state.fileList.data.data)
    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'file_name',
            cellRenderer: (params) =>
                <span>{params.data.file_type == 'jpg' ? <BsFillFileImageFill className='me-2' size={18} /> :
                    params.data.file_type == 'pdf' ? <FaFilePdf className='me-2' size={18} /> :
                        params.data.file_type == 'mp4' ? <FaFileVideo className='me-2' size={18} /> :
                            params.data.file_type == 'png' ? <BiSolidFilePng className='me-2' size={18} />
                                : <BiSolidFileDoc className='me-2' size={18} />}


                    {params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            width: 500
        },
        // {
        //     headerName: 'TYPE',
        //     field: 'file_type',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     wrapText: true,
        //     autoHeight: true,
        // },
        {
            headerName: 'SIZE',
            field: 'size',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <a href={process.env.REACT_APP_IMAGE_URL + `${params.data.file_path}`} target='_blank'>
                        <FaEye size={20} className='eye'
                            // onClick={() => question_details(params)}
                            data-tooltip-id='details'
                            data-tooltip-content="Open File!"
                            data-tooltip-place="bottom"
                        />
                    </a>

                    {role == "Instructor" ? '' :
                        <FaTrash size={18} className='delete ms-3'
                            onClick={() => delete_file(params)}
                            data-tooltip-id='delete'
                            data-tooltip-content="Delete File!"
                            data-tooltip-place="bottom"
                        />
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='delete' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const uploads = (file) => {
        if (file) {
            dispatch(uploadTodo(file)).then(() => upload_res())
            setLoading(true)
        }
    }

    const upload_res = () => {
        // console.log(uploadRes)
        if (uploadRes && uploadRes.success) {
            dispatch(addFileTodo({ "folder_id": state.id, "file_path": uploadRes.data.path, "file_type": uploadRes.data.file_type, "file_size": uploadRes.data.size })).then(() => uploaded_res())
            // toast.success(uploadRes.message, { position: "bottom-right" })
            var file_reset = document.querySelectorAll('.file')
            for (var i = 0; i < file_reset.length; i++) {
                file_reset[i].value = '';
            }
            setLoading(true)
        } else {
            toast.error(uploadRes.message, { position: "bottom-right" })
            var file_reset = document.querySelectorAll('.file')
            for (var i = 0; i < file_reset.length; i++) {
                file_reset[i].value = '';
            }
        }
    }

    const uploaded_res = () => {
        if (addFileRes && addFileRes.success) {
            toast.success(addFileRes.message, { position: "bottom-right" })
            setBool(!bool)
        } else {
            toast.error(addFileRes.message, { position: "bottom-right" })
            setBool(!bool)
        }
    }

    const file_list_res = () => {
        if (fileListRes && fileListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const delete_file = (params) => {
        Swal.fire({
            title: 'Delete File',
            text: `Are you sure want to Delete File?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(val)
                setLoading(true)
                dispatch(deleteFileTodo(params.data.id)).then(() => del_file_res())
            }
        })
    }

    const del_file_res = () => {
        if (deleteFileRes && deleteFileRes.success) {
            Swal.fire(
                'File Status',
                deleteFileRes.message,
                'success'
            )
            // toast.success(deleteFileRes.message, { position: "bottom-right" })
            setLoading(true)
            dispatch(fileListTodo(state.id)).then(() => file_list_res())
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: deleteFileRes.message,
            })
            // console.log('else', deleteFileRes)
            // toast.error(deleteFileRes.message, { position: "bottom-right" })
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(fileListTodo(state.id)).then(() => file_list_res())
    }, [bool])

    return (
        <>
            <div className='container'>
                <div className='scnd-header'>
                    <span className='icon1'>File Library / </span>
                    <Link to={"/library"}><span className='icon2'> Folder / </span></Link>
                    <span className='icon2'>Files</span>
                </div>

                <div className='d-flex justify-content-between align-items-center mb-3'>
                    {/* <input type="file" id="file" style={{ display: "none" }} />
                    <label htmlFor="file"><ImAttachment size={25} /></label> */}
                    <div>
                        <h5>{state && state.folder_name}</h5>
                        <span style={{ color: '#9d9d9d' }}>{state && state.description}</span>
                    </div>

                    {role == "Instructor" ? '' :
                        <>
                            <input type='file' id="file" className='file' onChange={(e) => uploads(e.currentTarget.files[0])} style={{ display: 'none' }} />
                            <label className='btn btn_submit' type='button' htmlFor="file">Add File</label>
                        </>
                    }
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                        height={'55vh'}
                    />
                }
            </div>

            <ToastContainer />
        </>
    )
}
